import styles from './TeamMemberTags.module.scss';

import { TagDto } from 'api/dtos/tag';

type Props = {
    tags: TagDto[];
}

const TeamMemberTags = ({
    tags,
}: Props) => (
    <div>
        <div className={styles.elements}>
            {tags.map((element, index) => (
                <span
                    key={element.id}
                >
                    {index + 1 === tags.length || tags.length === 1 ? element.name : `${element.name}, `}
                </span>
            ))}
        </div>
    </div>

);

export default TeamMemberTags;
